import useAddCourier from "api/UserResource/useAddCourier";
import FormField from "components/v2/FormField";
import { Form, Formik } from "formik";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { IoIosArrowForward } from "react-icons/io";
import { phoneRegex } from "utils";
import * as Yup from "yup";

const AddCourier = () => {
	const [showForm, setShowForm] = useState(false);

	const initialValues = {
		username: "",
		email: "",
		mobile_number: "",
		first_name: "",
		last_name: "",
	};

	const validate = Yup.object().shape({
		email: Yup.string()
			.required("Email address is required")
			.email("Invalid email address"),
		first_name: Yup.string().required("First name is required"),
		last_name: Yup.string().required("Surname is required"),
		mobile_number: Yup.string()
			.required("Mobile number is required")
			.matches(phoneRegex, "Invalid phone number")
			.min(10, "Mobile number must have at least characters")
			.max(20, "Mobile number cannot exceed 20 characters"),
	});

	const { mutateAsync, isLoading } = useAddCourier();

	const handleAddCourier = async (data) => {
		try {
			await mutateAsync(data);
			setShowForm(false);
		} catch (error) {
			// console.log(error);
		}
	};

	return (
		<>
			<button
				onClick={() => setShowForm(true)}
				className="bg-akgreen text-white px-4 py-2 rounded-full"
			>
				Add new courier
			</button>

			<Dialog
				visible={showForm}
				style={{ width: "50vw" }}
				header={
					<div className="text-xl font-sans font-bold sticky top-4 z-20 bg-white mr-2">
						<p className="">Add courier</p>
					</div>
				}
				onHide={() => setShowForm(false)}
				position="top"
				draggable={false}
				contentClassName="rounded-b-xl "
				className="rounded-xl relative"
			>
				<Formik
					initialValues={initialValues}
					validationSchema={validate}
					onSubmit={handleAddCourier}
				>
					{({ values, errors, touched }) => {
						return (
							<Form className="space-y-6 py-6">
								<FormField
									name="first_name"
									label="First name *"
								/>
								<FormField
									name="last_name"
									label="Last name *"
								/>
								<FormField
									type="text"
									name="email"
									label="Email Address *"
								/>
								<FormField
									name="mobile_number"
									type="phone"
									label="Phone Number *"
									value={values.mobile_number}
									_onChange={(phone) => {
										if (phone !== "+") values.mobile_number = "+" + phone;
										else values.mobile_number = phone;
									}}
									error={Boolean(errors.mobile_number && touched.mobile_number)}
									errorText={errors.mobile_number}
								/>

								<div className="flex justify-center">
									<button
										type="submit"
										className="px-4 py-2 rounded-full text-white flex gap-1 items-center justify-center bg-akgreenest"
									>
										<span>Submit</span>

										{isLoading ? (
											<AiOutlineLoading3Quarters
												size={20}
												className="animate-spin"
											/>
										) : (
											<IoIosArrowForward size={20} />
										)}
									</button>
								</div>
							</Form>
						);
					}}
				</Formik>
			</Dialog>
		</>
	);
};

export default AddCourier;
